var React = require('react');

function CopyIconClipboard (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M6 0.5C5.44772 0.5 5 0.947715 5 1.5C5 2.05228 5.44772 2.5 6 2.5H11C12.6569 2.5 14 3.84315 14 5.5V10.5C14 11.0523 14.4477 11.5 15 11.5C15.5523 11.5 16 11.0523 16 10.5V5.5C16 2.73858 13.7614 0.5 11 0.5H6ZM4 5.5H9C10.1046 5.5 11 6.39543 11 7.5V12.5C11 13.6046 10.1046 14.5 9 14.5H4C2.89543 14.5 2 13.6046 2 12.5V7.5C2 6.39543 2.89543 5.5 4 5.5ZM0 7.5C0 5.29086 1.79086 3.5 4 3.5H9C11.2091 3.5 13 5.29086 13 7.5V12.5C13 14.7091 11.2091 16.5 9 16.5H4C1.79086 16.5 0 14.7091 0 12.5V7.5Z","fill":"white"}));
}

CopyIconClipboard.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = CopyIconClipboard;

CopyIconClipboard.default = CopyIconClipboard;
